export enum InfillTypes {
  glassClear = 'glassClear',
  glassSmoke = 'glassSmoke',
  glassDark = 'glassDark',
  laserCutAgama = 'laserCutAgama',
  laserCutBound = 'laserCutBound',
  laserCutCubist = 'laserCutCubist',
  laserCutPisces = 'laserCutPisces',
  laserCutRhythm = 'laserCutRhythm',
  laserCutSeagrass = 'laserCutSeagrass',
  laserCutSverra = 'laserCutSverra',
  laserCutTrillium = 'laserCutTrillium',
  laserCutPulse = 'laserCutPulse',
  // Kerri Kelly Collection — placeholder keys until Feeney provides final design names
  laserCutKelly1 = 'laserCutKelly1',
  laserCutKelly2 = 'laserCutKelly2',
  laserCutKelly3 = 'laserCutKelly3',
  laserCutKelly4 = 'laserCutKelly4',
  laserCutKelly5 = 'laserCutKelly5',
  laserCutKelly6 = 'laserCutKelly6',
  laserCutKelly7 = 'laserCutKelly7',
  laserCutKelly8 = 'laserCutKelly8',
  laserCutKelly9 = 'laserCutKelly9',
  steelMeshAllure = 'steelMeshAllure',
  steelMeshDazzle = 'steelMeshDazzle',
  steelMeshMetropolitan = 'steelMeshMetropolitan',
  steelMeshHorizon = 'steelMeshHorizon'
}

// Glass, laser-cut and steel-mesh infills are all backend panel products cut to
// segment size; anything listed in InfillTypes goes through that shared path.
export function isPanelInfill(value: string): boolean {
  return !!value && Object.prototype.hasOwnProperty.call(InfillTypes, value);
}

export function isLaserCutInfill(value: string): boolean {
  return !!value && value.indexOf('laserCut') === 0;
}



// WEBPACK FOOTER //
// ./src/app/services/railing/infills/model/infill-types.ts